import { ProductEntryVector } from "@imi-ernd-be/hyselect-engine";
import { withDelete } from "../helpers/withDelete";
import { toArray } from "../vector";
import { ProductEntry } from "./types";

export function buildProductEntries(
  productEntryVector: ProductEntryVector | null | undefined,
  cleanup = true,
): ProductEntry[] {
  if (!productEntryVector) return [];
  return toArray(productEntryVector).map((product) =>
    withDelete(cleanup ? [product] : [], {
      articleNumber: product.articleNumber,
      deleted: product.deleted,
      hasSubProducts: product.hasSubProducts,
      id: product.id,
      name: product.name,
      type: product.type,
    }),
  );
}
